import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGetVideoList, IVideo } from "../api/controllers/get-video-list";
import GlobalHelmetProvider from "../components/global/GlobalHelmetProvider";
import "../styles/home.scss";
import { getAssetUrl } from "../utils/get-asset-url";

interface HomeLink {
  label: string;
  text: string;
  url: string;
}
interface HomeContent {
  name: string;
  tagline: string;
  bio: string;
  photo: string;
  links: HomeLink[];
}

const Home = () => {
  const [content, setContent] = useState<HomeContent>();
  const [latest, setLatest] = useState<IVideo[]>([]);

  useEffect(() => {
    fetch("/data/home.json")
      .then((r) => r.json())
      .then(setContent)
      .catch(() => {});
    apiGetVideoList()
      .then((res) => setLatest(res.data.slice(0, 3)))
      .catch(() => {});
  }, []);

  if (!content) return <div className="min-h-[70vh]" />;

  const [first, ...rest] = content.name.split(" ");
  const last = rest.join(" ");

  return (
    <main className="page home">
      <GlobalHelmetProvider title={content.name} description={content.tagline} />

      <section className="home-hero">
        <p className="home-tagline">
          <span>{content.tagline}</span>
          <svg className="home-marker" viewBox="0 0 300 14" preserveAspectRatio="none" aria-hidden="true">
            <path d="M3 9 C 40 5, 80 11, 120 8 S 200 4, 240 8 S 285 9, 297 6" />
            <path d="M6 11 C 50 9, 90 12, 140 10 S 210 8, 250 11 S 280 10, 294 9" />
          </svg>
        </p>
        <h1 className="home-name" aria-label={content.name}>
          <span>{first}</span>
          <span>{last}</span>
        </h1>
        <div className="home-row">
          <p className="home-bio">{content.bio}</p>
          <div className="home-photo">
            <img src={getAssetUrl(content.photo)} alt="" />
          </div>
          <ul className="home-links">
            {content.links.map((l) => (
              <li key={l.url}>
                <span className="home-link-label">{l.label}</span>
                <a href={l.url} target={l.url.startsWith("mailto:") ? undefined : "_blank"} rel="noreferrer">
                  {l.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {latest.length > 0 && (
        <section className="home-latest">
          <div className="home-latest-head">
            <span>Latest</span>
            <Link to="/videos">All videos</Link>
          </div>
          <div className="home-latest-grid">
            {latest.map((v) => (
              <Link to={`/videos/${v.attributes.video_slug}`} className="home-latest-card" key={v.id}>
                <img src={getAssetUrl(v.attributes.thumb_url.data.attributes.formats.small.url)} alt="" />
                <span>{v.attributes.title}</span>
              </Link>
            ))}
          </div>
        </section>
      )}
    </main>
  );
};

export default Home;
